import {
    FETCH_REFERRAL_MILESTONES_REQUEST,
    FETCH_REFERRAL_MILESTONES_SUCCESS,
    FETCH_REFERRAL_MILESTONES_FAILURE,
} from "../actions/types";

const initialState = {
    milestones: [],
    loading: false,
    error: null,
    message: "",
};

export default function referralMilestoneReducer(
    state = initialState,
    action
) {
    switch (action.type) {
        case FETCH_REFERRAL_MILESTONES_REQUEST:
            return {
                ...state,
                loading: true,
                error: null,
            };

        case FETCH_REFERRAL_MILESTONES_SUCCESS:
            return {
                ...state,
                loading: false,
                milestones: action.payload,
                message:
                    "Referral milestones loaded successfully",
            };

        case FETCH_REFERRAL_MILESTONES_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload,
            };

        default:
            return state;
    }
}